import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const CustomersApi = createApi({
	reducerPath: "Customers",
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1`,
		credentials: "include",
	}),
	endpoints: (builder) => ({
		getAllCustomers: builder.query({
			query: (val) => {
				const page = val.page ?? 1;
				const limit = val.limit ?? 10000;
				const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
				const sortOrder = val.sortorder ? `&sortOrder=${val.sortorder}` : "";
				const search = val.search ? `&search=${val.search}` : "";
				const queryString = val.queryString
					? `&${val.queryString.substring(1)}`
					: "";
				return `/customers?page=${page}&limit=${limit}${search}${sortBy}${sortOrder}${queryString}`;
			},
		}),

		getSingleCustomer: builder.query({
			query: (userId) => `/customers/${userId}`,
		}),
		getChildCustomer: builder.query({
			query: (userId) => `/customers/connections/${userId}`,
		}),
		addCustomer: builder.mutation({
			query: (val) => ({
				url: `/customers`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		editCustomer: builder.mutation({
			query: ({ id, val }) => ({
				url: `/customers/${id}`,
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		deleteCustomer: builder.mutation({
			query: (id) => ({
				url: `/customers/${id}`,
				method: "DELETE",
			}),
		}),
	}),
});

export const {
	useGetAllCustomersQuery,
	useGetSingleCustomerQuery,
	useGetChildCustomerQuery,
	useAddCustomerMutation,
	useEditCustomerMutation,
	useDeleteCustomerMutation,
} = CustomersApi;
